import router from './router'
import { isAuthenticated } from '@/util/http'
import { parseQueryString } from '@safety/shared-utils'

export function useRouter(authStore) {
  const routeGuard = async (to, from) => {
    if (to.path === '/error') {
      if (from.path === '/error' && to.query.message === from.query.message) return false
      return true
    }
    try {
      const ok = await isAuthenticated()
      if (ok) {
        if (to.path === '/login') {
          if (to.query.__prev) {
            const url = decodeURIComponent(to.query.__prev)
            const { path, query } = parseQueryString(url)
            return { path, query }
          } else {
            return { path: '/' }
          }
        }

        if (to.path !== '/login' && to.path !== '/error' && to.path !== '/403') {
          const hasAuth = authStore.checkRoute(to)
          if (!hasAuth) {
            console.warn(`没有权限访问路由: ${to.path}`)
            return { path: '/error', query: { message: '您没有权限访问此页面' } }
          }
        }
      } else {
        if (to.path !== '/login') {
          return { path: '/login', query: { __prev: encodeURIComponent(to.fullPath) } }
        }
      }
    } catch (error) {
      return { path: '/error', query: { message: '服务器请求失败' } }
    }
  }

  router.beforeEach(routeGuard)

  return router
}

export default {
  useRouter
}
